import { lazy } from 'react';
/** Открывает список уровней кэшбэка */
export const CashbackLevelsPageAsync = lazy(() => import('./CashbackLevels/CashbackLevelsPage'));
